import React, { useEffect, useRef } from 'react';

import styled from 'styled-components';

import useMediaQuery from 'hooks/use-media-query';
import { isWeb } from 'utils/environment';

const Container = styled.div`
  text-align: center;
  margin-top: 10rem;
  line-height: 2rem;
`;

const DownloadFileWidget = ({ widgets }) => {
  const isMobile = useMediaQuery('mobile');
  const linkRef = useRef(null);

  useEffect(() => {
    if (isWeb && isMobile) {
      linkRef.current?.click();
    }
  }, [isMobile]);

  // This work-around needs to happen only when we are on the web app
  // but we are using the mobile simulator due to legal requirements
  if (!(isWeb && isMobile)) {
    document.location.href = widgets[0]?.url?.locale;
    return null;
  }

  return (
    <Container>
      <div>Your download will start shortly...</div>
      <div>
        If you're having trouble you can{' '}
        <a
          data-testid="file-url"
          href={widgets[0]?.url?.locale}
          rel="noreferrer"
          target="_blank"
          ref={linkRef}
        >
          click here
        </a>
        .
      </div>
    </Container>
  );
};

export default DownloadFileWidget;
